import React from "react"

import styled from "styled-components"
import NextImg from "@/common/components/NextImg/index"
import { theme } from "./mixin"

export default function RewardCard({ img, title, discount }) {
  return (
    <Wrapper>
      <TopWrapper>
        <ImageWrapper>
          <NextImg src={img} />
        </ImageWrapper>
      </TopWrapper>
      <BottomWrapper>
        <TitleWrapper>
          <h3>{title}</h3>
        </TitleWrapper>
        <ContentWrapper>
          <h3>$</h3>
          <h2>{discount}</h2>
          <p>折價券</p>
        </ContentWrapper>
      </BottomWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  border-radius: 40px;
  overflow: hidden;
  filter: drop-shadow(1px 1px 12px rgba(0, 0, 0, 0.082));
  &:after {
    content: "";
    border: 1000px solid #ffffff;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
  @media (${theme.md}) {
    border-radius: 23px;
  }
`
const TopWrapper = styled.div`
  background-color: #ffffff;
  padding: 8px;
`
const ImageWrapper = styled.div`
  border-radius: 32px;
  overflow: hidden;
  @media (${theme.md}) {
    border-radius: 16px;
  }
`

const BottomWrapper = styled.div`
  position: relative;
  padding-bottom: 30px;
`
const TitleWrapper = styled.div`
  h3 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    font-size: 32px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 20px;
    }
  }
`
const ContentWrapper = styled.div`
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    font-size: 76px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 54px;
    }
  }
  h3 {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    font-size: 54px;
    margin: 0;
    @media (${theme.md}) {
      font-size: 36px;
    }
  }
  p {
    font-family: ${theme.titleFonts};
    font-weight: 700;
    line-height: 1.2;
    color: ${({ color }) => (color ? color : theme.secondary)};
    writing-mode: vertical-lr;
    margin: 0;
    font-size: 20px;
    @media (${theme.md}) {
      font-size: 16px;
    }
  }
`

const A = styled.div``
